module.exports = __webpack_public_path__ + "static/media/hell_run_platformer.25859505.png";